import { filterConfiguration } from 'app/components/filters/filters-panel/filter-configuration';
import { Filter, FilterTypes } from 'app/components/filters/types';
import { endpoint } from 'app/area/filters/constants';
import { FilterCodeFlat } from 'app/components/filters/filters-panel/filter-types/filter-code/filter-code-flat';
import { createConditionValue } from 'app/components/filters/filters-panel/filter-types/filter-code-hierarchy/create-condition-value';
import { createFavouriteCondition } from 'app/components/filters/filters-panel/conditions/create-conditions';
import { getConditionForOperator } from '../get-condition';

export const selectMultipleFlatConfiguration = {
  [FilterTypes.SelectMultipleFlat]: filterConfiguration(
    FilterCodeFlat,
    endpoint.filterOptionsFor
  )
};

export const selectMultipleFlatWithCategoriesConfiguration = {
  [FilterTypes.SelectMultipleFlatWithCategories]: filterConfiguration(
    FilterCodeFlat,
    endpoint.filterOptionsFor,
    [],
    endpoint.filterCategoryOptionsFor,
    true
  )
};

export const selectMultipleFlatSequentialWithCategoriesConfiguration = {
  [FilterTypes.SelectMultipleFlatSequentialWithCategories]: filterConfiguration(
    FilterCodeFlat,
    endpoint.filterOptionsFor,
    [],
    endpoint.filterCategoryOptionsFor,
    true
  )
};

export const selectMultipleFlatConditionMapper = (editingValues: any) => {
  const mapper = (filter: Filter) => {
    let condValIndex = 1;

    const editingValue = editingValues?.[filter.id];
    const value = editingValue?.value;
    const conditionValue = createConditionValue(condValIndex++, filter, value);
    const originalCondition = getConditionForOperator(filter.conditions, filter.advancedField.valueOperator);

    return conditionValue ? [createFavouriteCondition(filter, conditionValue, originalCondition)] : [];
  };

  return {
    [FilterTypes.SelectMultipleFlat]: mapper,
    [FilterTypes.SelectMultipleFlatWithCategories]: mapper,
    [FilterTypes.SelectMultipleFlatSequentialWithCategories]: mapper
  };
};
